<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item
          v-if="form.battleTaskId"
          label="任务ID"
          prop="battleTaskId"
        >
          {{ form.battleTaskId }}
        </el-form-item>
        <el-form-item label="游戏" prop="gameId">
          <el-select v-model="form.gameId" placeholder="请选择游戏" class="fix-width" :disabled='!!form.battleTaskId' @change="changeGame()">
            <el-option
              v-for="item in gameList"
              :key="item.gameId"
              :label="item.title"
              :value="item.gameId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.gameId" label="所属战队" prop="battleTeamIdList">
          <el-checkbox-group v-model="form.battleTeamIdList">
            <el-checkbox v-for="(item,index) of teamList" :label="item.battleTeamId" :key="index">{{item.title}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="类型" prop="typehood">
          <el-select
            v-model="form.typehood"
            placeholder="请选择类型"
            class="fix-width"
          >
            <el-option
              v-for="item in gameType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 扫码列表 -->
        <el-form-item
          label="子任务列表"
          v-if="form.typehood === 1 || form.typehood === 2"
        >
          <el-button
            type="primary"
            size="mini"
            class="mb-10"
            @click="addCode(null)"
          >
            增加
          </el-button>
          <el-table :data="form.codeList">
            <el-table-column align="left" label="序号" width="55">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="标题"
              prop="title"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="编码"
              prop="code"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="积分"
              prop="score"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="备注"
              prop="text"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              fixed="right"
              label="操作"
              show-overflow-tooltip
              width="120px"
            >
              <template #default="{ $index }">
                <el-button type="text" @click="delCode($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 扫码列表 -->
        <el-form-item
          label="奖励积分"
          prop="score"
          v-if="form.typehood !== 1 && form.typehood !== 2"
        >
          <el-input-number
            v-model="form.score"
            :min="0"
            placeholder="奖励积分"
          />
        </el-form-item>
        <!-- <el-form-item label="最大可重复次数" prop="score">
          <el-input-number
            v-model="form.maxCount"
            :min="0"
            placeholder="最大可重复次数"
          />
        </el-form-item> -->
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
    <!-- 扫描列表 -->
    <el-dialog
      v-model="codeFormVisible"
      :close-on-click-modal="false"
      title="添加扫码列表"
      width="800px"
      @close="codeClose"
    >
      <el-form
        ref="codeForm"
        label-width="120px"
        :model="codeForm"
        :rules="codeFormRules"
      >
        <el-form-item label="标题" prop="title">
          <el-input
            class="fix-width"
            v-model="codeForm.title"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input
            class="fix-width"
            v-model="codeForm.code"
            placeholder="请输入编码"
          />
        </el-form-item>
        <el-form-item label="积分" prop="score">
          <el-input-number
            class="fix-width"
            v-model="codeForm.score"
            placeholder="请输入积分"
          />
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="codeForm.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="codeClose">取 消</el-button>
        <el-button type="primary" @click="codeSave">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  createBattleTask,
  updateBattleTask,
  findBattleTeamAll,
  findList
} from '@/api/game'
import { gameType } from '@/utils/const'
export default {
  name: 'TaskEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      gameType,
      teamList: [],
      gameList:[],
      form: {
        gameId:'',
        //关联的战队
        battleTeamIdList: [],
        battleTaskId: '',
        typehood: 1,
        codeList: [],
        title: '',
        score: 100,
        // maxCount: 1,
        text: '',
        order: 1,
      },
      rules: {
        gameId:[{ required: true, trigger: 'blur', message: '请选择游戏' }],
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        battleTeamIdList:[{required:true, trigger: 'blur', message: '请至少选择一个战队' }]
      },
      // 扫码列表
      codeForm: {
        code: '',
        score: '',
        title: '',
        text: '',
      },
      codeFormRules: {
        code: [{ required: true, trigger: 'blur', message: '请输入编码' }],
        score: [{ required: true, trigger: 'blur', message: '请输入积分' }],
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      },
      dialogFormVisible: false,
      codeFormVisible: false,
    }
  },
  methods: {
    //获取游戏列表
    async getGameList() {
      const { list } = await findList({page:1,size:10000})
      this.gameList = list
    },
    async changeGame() {
      this.getTeamList()
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改游戏任务'
        this.form = Object.assign(this.form, row.basic)
        this.form.battleTaskId = row.battleTaskId
        this.form.typehood = row.typehood
        this.form.gameId = row.gameId
        this.form.battleTeamIdList = row.basic.battleTeamIdList
        this.form.title = row.title
      } else {
        this.title = '新增游戏任务'
      }
      this.getTeamList()
      this.getGameList()
      this.dialogFormVisible = true
    },
    //获取游戏战队
    async getTeamList() {
      const list = await findBattleTeamAll({
        gameId: this.form.gameId,
      })
      this.teamList = list
    },
    delCode(index) {
      this.form.codeList.splice(index, 1)
    },
    addCode() {
      this.codeFormVisible = true
    },
    codeClose() {
      this.$refs['codeForm'].resetFields()
      this.codeForm = this.$options.data().codeForm
      this.codeFormVisible = false
    },
    codeSave() {
      this.$refs['codeForm'].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.codeForm)
          this.form.codeList.push(form)
          this.codeClose()
        } else {
          return false
        }
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const battleTaskId = this.form.battleTaskId
          const data = Object.assign({}, this.form)
          if (data.typehood !== 1 && data.typehood !== 2) {
            data.codeList = []
          }
          this.$baseConfirm(
            `你确定要${battleTaskId ? '修改' : '新增'}游戏任务吗`,
            null,
            async () => {
              battleTaskId
                ? await updateBattleTask(data)
                : await createBattleTask(data)
              this.$baseMessage(
                `${battleTaskId ? '修改' : '新增'}游戏任务成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
